import { translateText, localLanguageCatalogs } from "../../../helpers/LanguageHelper";
import React, { useEffect, useState } from 'react';
import { useParams, Link, useNavigate } from 'react-router-dom';
import SiteBreadcrumb from '../../components/layout/SiteBreadcrumb';
import BestFacilities from '../../components/shared/BestFacilities';
import { useSelector, useDispatch } from 'react-redux';
import { LOADER_DURATION } from '../../../helpers/Constants';
import { showErrorMsg, showSuccessMsg, validateAnyFormField } from '../../../helpers/ValidationHelper';
import { MakeApiCallSynchronous, MakeApiCallAsync } from '../../../helpers/ApiHelpers';
import Config from '../../../helpers/Config';
import rootAction from '../../../stateManagment/actions/rootAction';
import { Helmet } from 'react-helmet';
import { getLanguageCodeFromSession, GetLocalizationControlsJsonDataForScreen, replaceLoclizationLabel } from '../../../helpers/CommonHelper';
import GlobalEnums from '../../../helpers/GlobalEnums';
import { Input, Label, Row, Col, Form, FormGroup } from "reactstrap";

const indianStateNames = [
    'Andhra Pradesh', 'Arunachal Pradesh', 'Assam', 'Bihar', 'Chhattisgarh', 'Goa',
    'Gujarat', 'Haryana', 'Himachal Pradesh', 'Jharkhand', 'Karnataka', 'Kerala',
    'Madhya Pradesh', 'Maharashtra', 'Manipur', 'Meghalaya', 'Mizoram', 'Nagaland',
    'Odisha', 'Orissa', 'Punjab', 'Rajasthan', 'Sikkim', 'Tamil Nadu', 'Telangana',
    'Tripura', 'Uttar Pradesh', 'Uttarakhand', 'West Bengal', 'Andaman and Nicobar Islands',
    'Chandigarh', 'Dadra and Nagar Haveli', 'Daman and Diu', 'Delhi', 'New Delhi',
    'Jammu and Kashmir', 'Ladakh', 'Lakshadweep', 'Puducherry', 'Pondicherry'
];

const getLocalityError = (value, states) => {
    if (/(^|\D)\d{3}[\s-]?\d{3}(?!\d)/.test(value)) {
        return 'Enter your PIN code in the Postal Code field, not here.';
    }

    const words = value.toLowerCase().match(/[\p{L}\p{M}\p{N}]+/gu) || [];
    const englishStateNames = [...indianStateNames, ...states.map((state) => state.StateName).filter(Boolean)];
    const stateNames = [...englishStateNames, ...Object.keys(localLanguageCatalogs).flatMap(language =>
        englishStateNames.map(name => translateText(name, language)))];
    const containsState = stateNames.some((name) => {
        const stateWords = name.toLowerCase().match(/[\p{L}\p{M}\p{N}]+/gu) || [];
        return stateWords.length > 0 && words.some((_, start) => {
            let combined = '';
            const stateName = stateWords.join('');
            for (let index = start; index < words.length && combined.length < stateName.length; index++) {
                combined += words[index];
                if (combined === stateName) return true;
            }
            return false;
        });
    });

    return containsState ? 'Select your state in the State field, not here.' : '';
};

const Signup = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [siteTitle, setSiteTitle] = useState(Config['SITE_TTILE']);
    const [FirstName, setFirstName] = useState('');
    const [LastName, setLastName] = useState('');
    const [EmailAddress, setEmailAddress] = useState('');
    const [Password, setPassword] = useState('');
    const [ConfirmPassword, setConfirmPassword] = useState('');
    const [MobileNo, setMobileNo] = useState('');
    const [AddressLineOne, setAddressLineOne] = useState('');
    const [DoorNumber, setDoorNumber] = useState('');
    const [StreetName, setStreetName] = useState('');
    const [Landmark, setLandmark] = useState('');
    const [AddressCityName, setAddressCityName] = useState('');
    const [LocalityError, setLocalityError] = useState('');
    const [StateProvinceId, setStateProvinceId] = useState('');
    const [CityId, setCityId] = useState('');
    const [PostalCode, setPostalCode] = useState('');
    const [CountryID, setCountryID] = useState('');
    const [CountriesList, setCountriesList] = useState([]);
    const [StatesProvincesList, setStatesProvincesList] = useState([]);
    const [CitiesList, setCitiesList] = useState([]);
    const [LocalizationLabelsArray, setLocalizationLabelsArray] = useState([]);

    const capitalizeAddressWords = (value) => value.replace(/\b[a-z]/g, (letter) => letter.toUpperCase());

    const handleLocalityChange = (event) => {
        const value = event.target.value;
        const error = getLocalityError(value, StatesProvincesList);
        setLocalityError(error);
        if (!error) setAddressCityName(capitalizeAddressWords(value));
    };

    useEffect(() => {
        const completeAddress = [DoorNumber, StreetName, AddressCityName, Landmark]
            .map((addressPart) => addressPart.trim())
            .filter(Boolean)
            .join(', ');

        setAddressLineOne(completeAddress);
    }, [DoorNumber, StreetName, Landmark, AddressCityName]);



    const HandleStateProvinceChagne = async (value) => {
        if (value != undefined) {
            await setStateProvinceId(value);

            //--load city data when state changed
            await LoadCitiesData(value);
        }

    }

    const HandleCountryChange = async (value) => {
        if (value != undefined) {
            await setCountryID(value);

            //--load state province data
            await LoadStateProvinceData(value);
        }

    }

    const LoadCitiesData = async (StateValue) => {
        const headersCity = {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        }


        const paramCity = {
            requestParameters: {
                StateProvinceId: StateValue ?? StateProvinceId,
                recordValueJson: "[]",
            },
        };

        //--Get cities list
        const responseCities = await MakeApiCallAsync(Config.END_POINT_NAMES['GET_CITIES_LIST'], null, paramCity, headersCity, "POST", true);
        if (responseCities != null && responseCities.data != null) {
            await setCitiesList(JSON.parse(responseCities.data.data));

        }
    }

    const LoadStateProvinceData = async (CountryValue) => {
        const headersStateProvince = {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        }


        const paramStateProvince = {
            requestParameters: {
                CountryId: CountryValue ?? CountryID,
                recordValueJson: "[]",
            },
        };

        //--Get state province list
        const responseStatesProvince = await MakeApiCallAsync(Config.END_POINT_NAMES['GET_STATES_PROVINCES_LIST'], null, paramStateProvince, headersStateProvince, "POST", true);
        if (responseStatesProvince != null && responseStatesProvince.data != null) {
            await setStatesProvincesList(JSON.parse(responseStatesProvince.data.data));

        }
    }
    const handleSignupForm = async (event) => {
        event.preventDefault();

        const localityError = getLocalityError(AddressCityName, StatesProvincesList);
        if (!AddressCityName.trim() || localityError) {
            setLocalityError(localityError || 'Enter your locality / remaining address.');
            return false;
        }

        try {


            let isValid = false;
            let validationArray = [];


            isValid = validateAnyFormField('First Name', FirstName, 'text', null, 200, true);
            if (isValid == false) {
                validationArray.push({
                    isValid: isValid
                });
            }


            isValid = validateAnyFormField('Last Name', LastName, 'text', null, 150, true);
            if (isValid == false) {
                validationArray.push({
                    isValid: isValid
                });
            }

            isValid = validateAnyFormField('Email', EmailAddress, 'email', null, 150, true);
            if (isValid == false) {
                validationArray.push({
                    isValid: isValid
                });
            }

            isValid = validateAnyFormField('Password', Password, 'password', null, 150, true);
            if (isValid == false) {
                validationArray.push({
                    isValid: isValid
                });
            }

            isValid = validateAnyFormField('Confirm Password', ConfirmPassword, 'password', null, 150, true);
            if (isValid == false) {
                validationArray.push({
                    isValid: isValid
                });
            }

            isValid = validateAnyFormField('Country', CountryID, 'text', null, 150, true);
            if (isValid == false) {
                validationArray.push({
                    isValid: isValid
                });
            }

            isValid = validateAnyFormField('Shipping address', AddressLineOne, 'text', null, 600, true);
            if (isValid == false) {
                validationArray.push({
                    isValid: isValid
                });
            }


            //--check if any field is not valid
            if (validationArray != null && validationArray.length > 0) {

                isValid = false;
                return false;
            } else {
                isValid = true;
            }


             //--check if password equals
             if (Password != ConfirmPassword) {
                showErrorMsg("Password does not match!");
                isValid = false;
            }

            if (isValid) {

                const headers = {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                }




                const param = {
                    requestParameters: {
                        FirstName: FirstName,
                        LastName: LastName,
                        EmailAddress: EmailAddress,
                        Password: Password,
                        MobileNo: MobileNo,
                        AddressLineOne: AddressLineOne,
                        CityId: CityId ?? -999,
                        StateProvinceId: StateProvinceId ?? -999,
                        PostalCode: PostalCode,
                        CountryID: CountryID ?? -999,
                    },
                };




                //--make api call for data operation
                const response = await MakeApiCallAsync(Config.END_POINT_NAMES['SIGNUP_USER'], null, param, headers, "POST", true);
                if (response != null && response.data != null) {
                    let userData = JSON.parse(response.data.data);
                    if (userData.length > 0 && userData[0].ResponseMsg != undefined && userData[0].ResponseMsg == "Saved Successfully") {
                        showSuccessMsg("Signup Successfully!");

                        //--CALL TO LOGIN API NOW TO LOGIN THE USER -- start here
                        const loginParam = {
                            requestParameters: {
                                Email: EmailAddress,
                                Password: Password
                            },
                        };

                        const responseLogin = await MakeApiCallAsync(Config.END_POINT_NAMES['GET_USER_LOGIN'], null, loginParam, headers, "POST", true);
                        if (responseLogin != null && responseLogin.data != null) {
                            let loginData = JSON.parse(responseLogin.data.data);
                            if (loginData.length > 0 && loginData[0].ResponseMsg != undefined && loginData[0].ResponseMsg == "Login Successfully") {

                                //--save user data in session
                                localStorage.setItem("user", JSON.stringify(loginData[0]));
                                dispatch(rootAction.userAction.setUser(JSON.stringify(loginData[0])));

                                //--set Token in local storage
                                localStorage.setItem("Token", responseLogin.data.token ?? "");


                                navigate('/' + getLanguageCodeFromSession() + '/');

                            } else {
                                navigate('/' + getLanguageCodeFromSession() + '/login');
                            }
                        } else {
                            navigate('/' + getLanguageCodeFromSession() + '/login');
                        }
                        //--CALL TO LOGIN API NOW TO LOGIN THE USER -- ends here



                    } else if (userData.length > 0 && userData[0].ResponseMsg != undefined && userData[0].ResponseMsg == "Email already exists!") {
                        showErrorMsg("Email already exists!");
                        return false;
                    } else {
                        showErrorMsg("An error occured. Please try again!");
                        return false;
                    }
                }
            }



        } catch (err) {
            console.log(err);
            showErrorMsg("An error occured. Please try again!");

            return false;

        } finally {
            //--stop loader
            setTimeout(() => {
                dispatch(rootAction.commonAction.setLoading(false));
            }, LOADER_DURATION);

        }
    }
    useEffect(() => {
        if (CountriesList?.length > 0) {
            // Try to find "United States" (or any other country name you prefer)
            const defaultCountry =
                CountriesList.find((c) => c.CountryName === "India")?.CountryID ||
                CountriesList[0].CountryID; // fallback to first in the list
    
            setCountryID(defaultCountry);
    
            // Optional: automatically load states for default country
            LoadStateProvinceData(defaultCountry);
        }
    }, [CountriesList]);

    useEffect(() => {

        
              // declare the data fetching function
        const dataOperationInUseEffect = async () => {

            const headers = {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            }


            const paramCountry = {
                requestParameters: {

                    recordValueJson: "[]",
                },
            };


            //--Get countreis list
            const responseCountries = await MakeApiCallAsync(Config.END_POINT_NAMES['GET_COUNTRIES_LIST'], null, paramCountry, headers, "POST", true);
            if (responseCountries != null && responseCountries.data != null) {
                await setCountriesList(JSON.parse(responseCountries.data.data));

            }

            //-- Get website localization data
            let arryRespLocalization = await GetLocalizationControlsJsonDataForScreen(GlobalEnums.Entities["Signup"], null);
            if (arryRespLocalization != null && arryRespLocalization != undefined && arryRespLocalization.length > 0) {
                await setLocalizationLabelsArray(arryRespLocalization);
            }


        }

        //--start loader
        dispatch(rootAction.commonAction.setLoading(true));

        // call the function
        dataOperationInUseEffect().catch(console.error);

        //--stop loader
        setTimeout(() => {
            dispatch(rootAction.commonAction.setLoading(false));
        }, LOADER_DURATION);


    }, [])


    return (
        <>
            <Helmet>
                <title>{siteTitle}{translateText(" - Sign Up")}</title>
                <meta name="description" content={siteTitle + " - Sign Up"} />
                <meta name="keywords" content="Sign Up"></meta>
            </Helmet>
            <SiteBreadcrumb title={translateText("Register")} parent="Home" />


            <section className="login-page section-big-py-space bg-light ukl-account-page ukl-signup-page">
                <div className="custom-container">


                    <Row className="row">
                        <Col xl="8" lg="8" md="8" className="offset-xl-2 offset-lg-2 offset-md-2">
                            <div className="theme-card ukl-account-card">
                                <h3 className="text-center">

                                    {translateText(LocalizationLabelsArray.length > 0 ?
                                        replaceLoclizationLabel(LocalizationLabelsArray, "Create an Account", "lbl_singup_crtaccount")
                                        :
                                        "Create an Account")
                                    }


                                </h3>
                                <p className="ukl-account-intro">{translateText("Create your account to order faster and manage deliveries easily.")}</p>
                                <Form className="theme-form ukl-account-form" onSubmit={handleSignupForm}>
                                    <div className="form-row row">
                                        <Col md="6">
                                            <FormGroup>

                                                <Label htmlFor="FirstName">
                                                    {translateText(LocalizationLabelsArray.length > 0 ?
                                                        replaceLoclizationLabel(LocalizationLabelsArray, "First Name", "lbl_singup_fname")
                                                        :
                                                        "First Name")
                                                    }
                                                    <span className="required-field">*</span></Label>
                                                <Input type="text" className="form-control" placeholder={translateText("Enter first name")} id="FirstName" name="FirstName"
                                                    required={true}
                                                    value={FirstName}
                                                    onChange={(e) => setFirstName(capitalizeAddressWords(e.target.value))}
                                                />

                                            </FormGroup>
                                        </Col>
                                        <Col md="6">
                                            <FormGroup>
                                                <Label htmlFor="LastName">
                                                    {translateText(LocalizationLabelsArray.length > 0 ?
                                                        replaceLoclizationLabel(LocalizationLabelsArray, "Last Name", "lbl_singup_lname")
                                                        :
                                                        "Last Name")
                                                    }
                                                    <span className="required-field">*</span></Label>
                                                <Input type="text" className="form-control" placeholder={translateText("Enter last name")} id="LastName" name="LastName"
                                                    required={true}
                                                    value={LastName}
                                                    onChange={(e) => setLastName(capitalizeAddressWords(e.target.value))}
                                                />
                                            </FormGroup>
                                        </Col>
                                        <Col md="6">
                                            <FormGroup>

                                                <Label htmlFor="EmailAddress">
                                                    {translateText(LocalizationLabelsArray.length > 0 ?
                                                        replaceLoclizationLabel(LocalizationLabelsArray, "Email", "lbl_singup_email")
                                                        :
                                                        "Email")
                                                    }
                                                    <span className="required-field">*</span></Label>
                                                <Input type="email" className="form-control" placeholder={translateText("Enter email")} id="EmailAddress" name="EmailAddress"
                                                    required={true}
                                                    value={EmailAddress}
                                                    onChange={(e) => setEmailAddress(e.target.value)}
                                                />



                                            </FormGroup>
                                        </Col>
                                        <Col md="6" className="select_input" style={{ display: "none" }}>
                                            <FormGroup>
                                                <Label htmlFor="CountryID">
                                                    {translateText(LocalizationLabelsArray.length > 0 ?
                                                        replaceLoclizationLabel(LocalizationLabelsArray, "Country", "lbl_singup_country")
                                                        :
                                                        "Country")
                                                    }
                                                    <span className="required-field">*</span></Label>
                                                <select
                                                    className="form-control"
                                                    name="CountryID"
                                                    id="CountryID"
                                                    required={true}
                                                
                                                    onChange={(e) => HandleCountryChange(e.target.value)}
                                                >
                                                    <option value="-999">{translateText("Select Country")}</option>
                                                    {
                                                        CountriesList?.map((item, idx) =>

                                                            <option value={item.CountryID}>{translateText(item.CountryName)}</option>

                                                        )}


                                                </select>
                                            </FormGroup>
                                        </Col>
                                        <Col md="6">
                                            <FormGroup>
                                                <Label htmlFor="StateProvinceId">
                                                    {translateText(LocalizationLabelsArray.length > 0 ?
                                                        replaceLoclizationLabel(LocalizationLabelsArray, "State/Province", "lbl_singup_province")
                                                        :
                                                        "State/Province")
                                                    }
                                                </Label>

                                                <select
                                                    className="form-control"
                                                    name="StateProvinceId"
                                                    id="StateProvinceId"
                                                    required={false}
                                                    value={StateProvinceId}
                                                    onChange={(e) => HandleStateProvinceChagne(e.target.value)}
                                                >
                                                    <option value="-999">{translateText("Select State")}</option>
                                                    {
                                                        StatesProvincesList?.map((item, idx) =>

                                                            <option value={item.StateProvinceID}>{translateText(item.StateName)}</option>

                                                        )}


                                                </select>
                                            </FormGroup>
                                        </Col>
                                        <Col md="6">
                                            <FormGroup>
                                                <Label htmlFor="CityId">
                                                    {translateText(LocalizationLabelsArray.length > 0 ?
                                                        replaceLoclizationLabel(LocalizationLabelsArray, "City", "lbl_singup_city")
                                                        :
                                                        "City")
                                                    }
                                                </Label>

                                                <select
                                                    className="form-control"
                                                    name="CityId"
                                                    id="CityId"
                                                    required={false}
                                                    value={CityId}
                                                    onChange={(e) => setCityId(e.target.value)}
                                                >
                                                    <option value="-999">{translateText("Select City")}</option>
                                                    {
                                                        CitiesList?.map((item, idx) =>

                                                            <option value={item.CityID}>{translateText(item.CityName)}</option>

                                                        )}


                                                </select>

                                            </FormGroup>
                                        </Col>
                                        <Col md="6">
                                            <FormGroup>

                                                <Label htmlFor="MobileNo">
                                                    {translateText(LocalizationLabelsArray.length > 0 ?
                                                        replaceLoclizationLabel(LocalizationLabelsArray, "Contact No", "lbl_singup_contact")
                                                        :
                                                        "Contact No")
                                                    }
                                                    <span className="required-field">*</span>
                                                </Label>
                                                
                                                <Input type="number" className="form-control" placeholder={translateText("Enter contact no")} id="MobileNo" maxLength={10} name="MobileNo"
                                                    value={MobileNo}
                                                    required={true}
                                                    onChange={  (e) => {
                                                        if (e.target.value.length === 11) {
                                                            window.alert(
                                                                translateText("shouldn't exceed 10 numbers")
                                                            );
                                                        }
                                                        else
                                                        {
                                                        setMobileNo(e.target.value)}}
                                                    }
                                                />
                                            </FormGroup>
                                        </Col>
                                        <Col md="6">
                                            <FormGroup>
                                                <Label htmlFor="PostalCode">
                                                    {translateText(LocalizationLabelsArray.length > 0 ?
                                                        replaceLoclizationLabel(LocalizationLabelsArray, "Postal Code", "lbl_singup_pcode")
                                                        :
                                                        "Postal Code")
                                                    }
                                                </Label>
                                                <Input type="number" className="form-control" placeholder={translateText("Enter postal code")} id="PostalCode" name="PostalCode"
                                                    value={PostalCode}
                                                    onChange={  (e) => {
                                                        if (e.target.value.length === 7) {
                                                            window.alert(
                                                                translateText("shouldn't exceed 6 numbers")
                                                            );
                                                        }
                                                        else
                                                        { setPostalCode(e.target.value)}
                                                    }
                                                }
                                                />
                                            </FormGroup>
                                        </Col>
                                        <Col md="6">
                                            <FormGroup>
                                                <Label htmlFor="Password">
                                                    {translateText(LocalizationLabelsArray.length > 0 ?
                                                        replaceLoclizationLabel(LocalizationLabelsArray, "Password", "lbl_singup_password")
                                                        :
                                                        "Password")
                                                    }
                                                    <span className="required-field">*</span>
                                                </Label>
                                                <Input type="password" className="form-control" placeholder={translateText("Enter your password")} id="Password" name="Password"
                                                    required={true}
                                                    value={Password}
                                                    onChange={(e) => setPassword(e.target.value)}
                                                />
                                            </FormGroup>
                                        </Col>
                                        <Col md="6">
                                            <FormGroup>
                                                <Label htmlFor="ConfirmPassword">
                                                    {translateText(LocalizationLabelsArray.length > 0 ?
                                                        replaceLoclizationLabel(LocalizationLabelsArray, "Confirm Password", "lbl_singup_confpassword")
                                                        :
                                                        "Confirm Password")
                                                    }
                                                    <span className="required-field">*</span>
                                                </Label>
                                                <Input type="password" className="form-control" placeholder={translateText("Confirm Password")} id="ConfirmPassword" name="ConfirmPassword"
                                                    required={true}
                                                    value={ConfirmPassword}
                                                    onChange={(e) => setConfirmPassword(e.target.value)}
                                                />
                                            </FormGroup>
                                        </Col>
                                        <Col md="12">
                                            <div className="ukl-address-capture">
                                                <div className="ukl-address-capture__heading">
                                                    <span className="ukl-address-capture__icon" aria-hidden="true">
                                                        <i className="fa fa-map-marker" />
                                                    </span>
                                                    <div>
                                                        <Label>
                                                            {translateText(LocalizationLabelsArray.length > 0 ?
                                                                replaceLoclizationLabel(LocalizationLabelsArray, "Shipping Address", "lbl_singup_shippa")
                                                                :
                                                                "Shipping Address")
                                                            }
                                                            <span className="required-field">*</span>
                                                        </Label>
                                                        <p>{translateText("Enter each part so we can capture your complete delivery address.")}</p>
                                                    </div>
                                                </div>
                                                <Row>
                                                    <Col md="6">
                                                        <FormGroup>
                                                            <Label htmlFor="DoorNumber">{translateText("House / Flat / Door No")}<span className="required-field">*</span></Label>
                                                            <Input type="text" className="form-control" placeholder={translateText("e.g. 12B")} id="DoorNumber" name="DoorNumber"
                                                                required={true}
                                                                value={DoorNumber}
                                                                onChange={(e) => setDoorNumber(capitalizeAddressWords(e.target.value))}
                                                            />
                                                        </FormGroup>
                                                    </Col>
                                                    <Col md="6">
                                                        <FormGroup>
                                                            <Label htmlFor="StreetName">{translateText("Street / Road")}<span className="required-field">*</span></Label>
                                                            <Input type="text" className="form-control" placeholder={translateText("e.g. Lake View Road")} id="StreetName" name="StreetName"
                                                                required={true}
                                                                value={StreetName}
                                                                onChange={(e) => setStreetName(capitalizeAddressWords(e.target.value))}
                                                            />
                                                        </FormGroup>
                                                    </Col>
                                                    <Col md="12">
                                                        <FormGroup>
                                                            <Label htmlFor="AddressCityName">{translateText("Locality / Remaining Address")}<span className="required-field">*</span></Label>
                                                            <Input type="text" className="form-control" placeholder={translateText("e.g. Uthukuli, Tirupur")} id="AddressCityName" name="AddressCityName"
                                                                required={true}
                                                                value={AddressCityName}
                                                                onChange={handleLocalityChange}
                                                                aria-describedby={LocalityError ? 'locality-help locality-error' : 'locality-help'}
                                                            />
                                                            <small id="locality-help" className="form-text text-muted">{translateText("Enter locality / remaining address only. Use the separate State and Postal Code fields.")}</small>
                                                            {LocalityError && <small id="locality-error" className="text-danger d-block" role="alert">{translateText(LocalityError)}</small>}
                                                        </FormGroup>
                                                    </Col>
                                                    <Col md="12">
                                                        <FormGroup>
                                                            <Label htmlFor="Landmark">{translateText("Landmark")}</Label>
                                                            <Input type="text" className="form-control" placeholder={translateText("e.g. Near City Mall")} id="Landmark" name="Landmark"
                                                                value={Landmark}
                                                                onChange={(e) => setLandmark(capitalizeAddressWords(e.target.value))}
                                                            />
                                                        </FormGroup>
                                                    </Col>
                                                </Row>
                                                {AddressLineOne &&
                                                    <div className="ukl-address-capture__preview">
                                                        <span>{translateText("Complete address")}</span>
                                                        <strong>{AddressLineOne}</strong>
                                                    </div>
                                                }
                                                <input type="hidden" id="AddressLineOne" name="AddressLineOne" value={AddressLineOne} />
                                            </div>
                                        </Col>

                                        <Col md="12">
                                            <button className="btn btn-sm btn-normal mb-3 ukl-account-submit" type="submit" id="lbl_singup_submitbnt">
                                                {translateText(LocalizationLabelsArray.length > 0 ?
                                                    replaceLoclizationLabel(LocalizationLabelsArray, "Create Account", "lbl_singup_submitbnt")
                                                    :
                                                    "Create Account")
                                                }
                                            </button>


                                        </Col>

                                        <Col md="12">
                                            <p>{translateText("Have you already account?")}{" "}
                                                <a to={`/${getLanguageCodeFromSession()}/login`} className="txt-default">{translateText("click")}</a>


                                                {" "}{translateText("here to  ")}<Link to={`/${getLanguageCodeFromSession()}/login`} className="txt-default" id="lbl_singup_loginacnt">
                                                    {translateText(LocalizationLabelsArray.length > 0 ?
                                                        replaceLoclizationLabel(LocalizationLabelsArray, "Login", "lbl_singup_loginacnt")
                                                        :
                                                        "Login")
                                                    }
                                                </Link>
                                            </p>
                                        </Col>
                                    </div>
                                </Form>


                            </div>
                        </Col>
                    </Row>
                </div>
            </section>


        </>
    );
}

export default Signup;
